import { Response } from 'api/api.types';
import { PdfElement as PdfElementParent } from 'common/pdf-viewer/pdf-viewer.types';
import { Option } from 'common/form/select/select.types';

export interface GetDocumentRequest {
  unique_id: string;
}

export interface PdfDocument extends PdfElementParent {
  compactName: string;
  type: DocumentType;
}

export interface UploadDocumentsRequest {
  documents: { file: File; id: string; option: Option }[];
  unique_id: string;
}

export type DocumentType =
  | 'solicitud_primera_inscripcion'
  | 'solicitud_transferencia'
  | 'contrato_activacion_tag'
  | 'permiso_circulacion'
  | 'formulario_88'
  | 'factura'
  | 'seguro_obligatorio'
  | 'comprobante_banco'
  | 'tarjeta_vehicular'
  | 'homologado'
  | 'padron'
  | 'nota_credito'
  | 'cav'
  | 'mlt'
  | 'revision_tecnica'
  | 'porta_dox'
  | 'factura_electronica_exenta'
  | 'contrato';

export const DOCUMENT_TYPES: DocumentType[] = [
  'solicitud_primera_inscripcion',
  'solicitud_transferencia',
  'contrato_activacion_tag',
  'permiso_circulacion',
  'formulario_88',
  'factura',
  'seguro_obligatorio',
  'comprobante_banco',
  'tarjeta_vehicular',
  'homologado',
  'padron',
  'nota_credito',
  'cav',
  'mlt',
  'revision_tecnica',
  'porta_dox',
  'factura_electronica_exenta',
  'contrato',
];

export const CHECK_POINT_DOCS_AVAILABLE: DocumentType[] = [
  'padron',
  'homologado',
  'seguro_obligatorio',
  'permiso_circulacion',
  'revision_tecnica',
  'porta_dox',
];

export interface Documento {
  file_name: string;
  inserted_at: Date;
  type: DocumentType;
  unique_id: string;
}

export interface BillInfo {
  fecha_emision: Date;
  iva: string;
  monto_neto: string;
  monto_total: string;
  num_factura: string;
  rut_emisor: string;
}

export interface Adquiriente {
  complemento: string;
  comuna: string;
  correo: string;
  nombre: string;
  primer_apellido: string;
  r_domicilio: string;
  rut: string;
  segundo_apellido: string;
}

export interface CompraPara {
  complemento: string;
  comuna: string;
  correo: string;
  nombre: string;
  primer_apellido: string;
  r_domicilio: string;
  rut: string;
  segundo_apellido: string;
}

export interface Vehicle {
  anno: string;
  color: string;
  combustible: string;
  marca: string;
  modelo: string;
  no_chassis: string;
  no_motor: string;
  patente: string;
  pbv: string;
  tipo_vehiculo: string;
}

export interface VehicleDocumentsResult {
  adquirientes: Adquiriente[];
  compra_para: CompraPara;
  documentos: Documento[];
  documents: PdfDocument[];
  es_comprapara?: boolean;
  factura: BillInfo;
  vehiculo: Vehicle;
}

export interface VehicleDocumentsResponse extends Response {
  result: VehicleDocumentsResult;
}

export interface UploadDocumentsResponse extends Response {
  documentsFailure?: string[];
}
